<template>
  <q-item class="file-list-item">
    <q-item-section>
      <q-item-label>
        <PBtn
          :label="displayName"
          class="text-weight-medium"
          dense
          flat
          text
          @click="$emit('view', file)"
        />
      </q-item-label>
    </q-item-section>
    <q-item-section v-if="removable" side>
      <PBtn :loading="removing" dense flat round @click="$emit('remove', file)">
        <RemoveIcon class="icon--md" />
        <PTooltip>Remove</PTooltip>
      </PBtn>
    </q-item-section>
  </q-item>
</template>

<script setup>
import RemoveIcon from "assets/icons/remove.svg";

const props = defineProps({
  file: {
    type: Object,
    required: true,
  },
  removing: {
    type: Boolean,
    default: false,
  },
  removable: {
    type: Boolean,
    default: true,
  },
});

defineEmits(["view", "remove"]);

const displayName = computed(() => props.file.file_name ?? props.file.name);
</script>

<style lang="scss" scoped>
.file-list-item {
  border: 1px solid $neutral-50;
  border-radius: 8px;
  min-height: 54px;
  padding: 8px 12px;
  margin: 8px 0;

  &::before {
    content: "";

    transition: border-color 0.36s cubic-bezier(0.4, 0, 0.2, 1);

    border: 2px solid transparent;

    border-radius: 8px;

    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
  }

  &:hover::before {
    border-color: $primary-80;
  }

  &:focus-within::before {
    border-color: $primary;
  }
}
</style>
